module.exports = __webpack_public_path__ + "img/mision.7eb96894.png";